import { Component } from "react";

class DurationUtils extends Component {
  static less_20 = "less than 20 min";
  static between_20_and_30 = "20 to 30 min";
  static between_30_and_40 = "30 to 40 min";
  static more_40 = "more than 50 min";

  static durationRanges = [
    DurationUtils.less_20,
    DurationUtils.between_20_and_30,
    DurationUtils.between_30_and_40,
    DurationUtils.more_40,
  ];

  static getDurationRange = (hours, minutes, seconds) => {
    var toRet = "unknow";
    if (hours < 1) {
      if (minutes < 20) {
        toRet = DurationUtils.less_20;
      } else if (minutes >= 20 && minutes < 30) {
        toRet = DurationUtils.between_20_and_30;
      } else if (minutes >= 30 && minutes < 40) {
        toRet = DurationUtils.between_30_and_40;
      } else {
        toRet = DurationUtils.more_40;
      }
    } else {
      toRet = DurationUtils.more_40;
    }

    return toRet;
  };

  static getDurationRageOrder = (durationRange) => {
    if (durationRange === DurationUtils.less_20) {
      return 0;
    }
    if (durationRange === DurationUtils.between_20_and_30) {
      return 1;
    }
    if (durationRange === DurationUtils.between_30_and_40) {
      return 2;
    }
    if (durationRange === DurationUtils.more_40) {
      return 3;
    }
  };

  static getSpeed = (speed) => {
    if (speed === 0) {
      return 1;
    } else if (speed === 1) {
      return 1.5;
    } else if (speed === 2) {
      return 1.7;
    } else if (speed === 3) {
      return 2;
    } else {
      return 1;
    }
  };

  static getDurationImage = (range) => {
    if (range === DurationUtils.less_20) {
      return "./duration/duration_less_20.png";
    }
    if (range === DurationUtils.between_20_and_30) {
      return "./duration/duration_20_30.png";
    }
    if (range === DurationUtils.between_30_and_40) {
      return "./duration/duration_30_40.png";
    }
    if (range === DurationUtils.more_40) {
      return "./duration/duration_more_40.png";
    }
  };

  static calculateMatchDuration = (finished, started, speed) => {
    var seconds = Math.floor(finished - started);
    seconds = seconds * DurationUtils.getSpeed(speed);
    var minutes = Math.floor(seconds / 60);
    var hours = Math.floor(minutes / 60);

    minutes = minutes - hours * 60;
    seconds = seconds - hours * 60 * 60 - minutes * 60;

    return { hours, minutes, seconds };
  };
}

export default DurationUtils;
